import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import type { ParkTimeContract } from '@repo/domain';
import { Modal } from '@repo/ui';

import { useParkingSearchStore } from '@shared/stores/useParkingSearchStore';
import TimeContractPicker from '@shared/components/timeContract/TimeContractPicker';
import { PHONE_LAYOUT_CONTAINER_ID } from '@shared/constants/layout';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  testId: TestId;
}

export default function TimeContractPickerModal({ open, onOpenChange, testId }: Props) {
  const parkTimeContract = useParkingSearchStore((state) => state.parkTimeContract);
  const parkingId = useParkingSearchStore((state) => state.selectedParking.id);
  const spotId = useParkingSearchStore((state) => state.selectedParking.spotId);
  const setParkUntil = useParkingSearchStore((state) => state.setParkUntil);

  const handleClose = () => onOpenChange(false);

  const handleConfirm = (newContract: ParkTimeContract) => {
    setParkUntil(newContract);
    handleClose();
  };

  const portalTarget = document.getElementById(PHONE_LAYOUT_CONTAINER_ID) ?? undefined;

  return (
    <Modal open={open} onOpenChange={onOpenChange} portalTo={portalTarget} testId={testId}>
      <div className="mt-3 flex flex-col pb-0.5">
        <div className="text-heading justify-start text-xl leading-7 font-semibold">
          {tr('parking_search:park_duration.custom_time')}
        </div>

        <TimeContractPicker
          contract={parkTimeContract}
          onChange={handleConfirm}
          withPriceFor={parkingId}
          spotId={spotId}
          testId={testId.append('timeContractPicker')}
        />
      </div>
    </Modal>
  );
}
